import { SlideOver } from 'ui/slideOver';

import { usePanelContext } from '../../contexts/Panel';
import { PanelView } from '../../types';
import { PanelBody } from './PanelBody';
import { PanelFooter } from './PanelFooter';
import { PanelHeader } from './PanelHeader';

export const testIds = {
  panel: 'cl-panel',
};

export const AllImagesCreativeLibraryPanelContent = () => {
  const { onCancel, panelView } = usePanelContext();
  const showFooter = panelView === PanelView.Detail;

  return (
    <SlideOver
      bodyContent={<PanelBody />}
      data-test={testIds.panel}
      footerContent={showFooter && <PanelFooter />}
      headerContent={<PanelHeader />}
      id="creativeLibraryPanel"
      isOpen
      onClose={onCancel}
      onClickOutside={onCancel}
    />
  );
};
